// extracted by mini-css-extract-plugin
export default {"checkboxSVG":"OnmpY _3NgFG","checkboxSvg":"OnmpY _3NgFG","checkbox-container":"_3nVm-","checkboxContainer":"_3nVm-"};